<template>
  <div>
    <v-layout row wrap>
      <v-flex x12 hidden-xs-only text-md-right>
        <select-category :types="types" :category="category" @type="changeCategory"/>
      </v-flex>
    </v-layout>
    
    <moments-infinite :category="category" :key="category" />
  </div>
</template>

<script>
import MomentsInfinite from "./MomentsInfinite";
import SelectCategory from '../General/SelectCategory';

export default {
  components: {
    MomentsInfinite, SelectCategory
  },
  data() {
    return {
      category: "Todos",
      types: ["Fotos", "Videos", "Todos"]
    };
  },
  methods: {
    changeCategory(cat) {
      this.category = cat;
    }
  }
};
</script>

<style>
</style>
